<div class="app-card">
    <lib-file-browser 
        [treeData]="directoryData"
        [columnDefs]="columnDefs"
        (updateNode)="updateDirectory($event)"
        (onFileSelected)="onFileSelection($event)">
    </lib-file-browser>
</div>